import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import type React from 'react';
import {
  outlinedInputStyles,
  styles,
} from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopFilterNavBar/AllChoicesDropdown/AllChoicesDropdownStyles';

interface FacetEdge {
  key: string;
  doc_count: number;
  label?: string;
}

interface AllChoicesDropdownProps {
  data: FacetEdge[] | null;
  allChoices: string[];
  handleChoice: (event: SelectChangeEvent<string[]>) => void;
}

export default function AllChoicesDropdown({
  data,
  allChoices,
  handleChoice,
}: AllChoicesDropdownProps): React.ReactElement {
  const MenuProps = {
    variant: 'menu' as const,
    getContentAnchorEl: null,
    PaperProps: {
      style: {
        width: 'auto',
        maxHeight: 250,
      },
    },
  };

  const classes = styles();
  const outlinedInputClasses = outlinedInputStyles();

  const hasChoices = data && data.length > 0;

  return (
    <div>
      <FormControl className={classes.formControl} size="small">
        <Select
          labelId="demo-multiple-checkbox-label"
          id="cyp-filter-dropdown-choices"
          multiple
          value={allChoices}
          onChange={handleChoice}
          label="Choices"
          disabled={!hasChoices}
          displayEmpty
          input={<OutlinedInput classes={outlinedInputClasses} />}
          renderValue={(selected) => {
            if (!hasChoices) {
              return <Typography sx={{ color: 'text.disabled' }}>No values available</Typography>;
            }
            return (selected as string[]).join(', ');
          }}
          MenuProps={MenuProps}
        >
          {hasChoices &&
            data.map((edge, idx) => {
              return (
                <MenuItem key={edge.key} value={edge.key} id={`cyp-filter-choice-${idx}`}>
                  <Checkbox checked={allChoices && allChoices.indexOf(edge.key) > -1} />
                  <ListItemText primary={`${edge.label ?? edge.key} (${edge.doc_count})`} />
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </div>
  );
}
